import { Card, CardBody, Button } from '@chakra-ui/react';
import { SubHeading } from './SubHeading';

interface IProps {
  title: string;
  onClick: () => void;
}

export const TitleAndEditButton = (props: IProps) => (
  <Card variant="filled" mb={10}>
    <CardBody gap={{ base: 4, lg: 8 }}>
      <SubHeading>{props.title}</SubHeading>

      <Button onClick={props.onClick}>Change this</Button>
    </CardBody>
  </Card>
);
